import MembersProfileSection from "./components/MembersProfileSection";
import { useState } from "react";
import { IMessageJobMembersProfile, IRecentRoom } from "@endpoints/types/message.type";
import ChatSection from "./components/ChatSection";

export interface ISelectedContact extends IRecentRoom{
  participantDetails: IMessageJobMembersProfile['participantDetails']
}

const MessagePage = () => {
  const [selectedContact, setSelectedContact] =
    useState<ISelectedContact | null>(null);

  return (
    <div className="flex flex-col md:flex-row flex-1 rounded-md bg-white min-h-0 w-full">
      <MembersProfileSection
        selectedContact={selectedContact}
        setSelectedContact={setSelectedContact}
      />
      <ChatSection selectedContact={selectedContact} />
    </div>
  );
};

export default MessagePage;
